import Glide from '@glidejs/glide';


let glideProductPhotos = new Glide('#product-photos-slider', {
  type: 'carousel',
  perView: 1,
  startAt: 0,
  focusAt: 'center',
  gap: 0,
}).mount();

// reset videos when swiped so that we don't have multiple videos playing at once
function resetFrame() {
  const activeSlideIframe = document.querySelector(`ul.glide__slides .glide__slide--active iframe`);
  if (activeSlideIframe) {
    activeSlideIframe.src = activeSlideIframe.src;
  }
}
glideProductPhotos.on('run.before', resetFrame);



// Sync thumbnail clicks to the primary carousel
 document.querySelectorAll('.glide__thumbnail').forEach((element, index) => {
   element.addEventListener('click', () => {
    glideProductPhotos.go('=' + index);
  });
});




